import { useState, useCallback } from 'react';
import {
  WarrantExerciseService,
  type PagedResultDto_ParticipantWarrantDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

interface UseGetExercisableWarrantsResult {
  data: PagedResultDto_ParticipantWarrantDto | undefined;
  isLoading: boolean;
  fetchWarrants: (participantIds: string[]) => Promise<void>;
}

const useGetExercisableWarrantsForParticipants = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseGetExercisableWarrantsResult => {
  const [data, setData] = useState<PagedResultDto_ParticipantWarrantDto | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const fetchWarrants = useCallback(
    async (participantIds: string[]) => {
      console.log('participantIds', participantIds);
      if (participantIds.length === 0) return;
      setIsLoading(true);
      try {
        console.log('fetching warrants');
        const result = await handleRequest(
          WarrantExerciseService.getApiCapTableApiAppWarrantExerciseExercisableWarrantsForParticipants(
            participantIds
          )
        );
        console.log('result', result);
        setData(result);
      } catch (error) {
        console.error('fetchWarrants error:', {
          message: error.message,
          stack: error.stack,
          name: error.name,
          // Add any additional properties if available
        });

        setData(undefined);
      } finally {
        setIsLoading(false);
      }
    },
    [handleRequest]
  );

  return { data, isLoading, fetchWarrants };
};

export default useGetExercisableWarrantsForParticipants;
